import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ResumeReviewModal } from './components/ResumeReviewModal';
import { About } from './components/About';
import { Stats } from './components/Stats';
import { Certifications } from './components/Certifications';
import { Services } from './components/Services';
import { Industries } from './components/Industries';
import { BoardRoles } from './components/BoardRoles';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  const [reviewOpen, setReviewOpen] = useState(false);
  return <div className="min-h-screen bg-navy-900 font-sans selection:bg-gold selection:text-navy-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero onRequestReview={() => setReviewOpen(true)} data-id="element-3" />
        <About data-id="element-4" />
        <Stats data-id="element-5" />
        <Certifications data-id="element-6" />
        <Services data-id="element-7" />
        <Industries data-id="element-8" />
        <BoardRoles data-id="element-9" />
        <Process data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <Contact data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <ResumeReviewModal open={reviewOpen} onClose={() => setReviewOpen(false)} data-id="element-15" />
    </div>;
}